import { Box, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

function Spinner({ removeBox = false }) {
  if (removeBox) {
    return <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <CircularProgress />
    </Box>
  );
}

Spinner.propTypes = {
  removeBox: PropTypes.bool,
};

export default Spinner;
